import styled from "styled-components";

export const PageWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(180deg, #fffdf9 0%, #fffaf3 100%);
  padding: 200px 20px;
  @media (max-width: 768px) {
    padding: 140px 20px;
  }
`;

export const Container = styled.div`
  max-width: 980px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid rgba(196, 154, 108, 0.18);
  border-radius: 28px;
  box-shadow: 0 18px 60px rgba(0, 0, 0, 0.08);
  padding: 48px 40px;

  @media (max-width: 768px) {
    padding: 32px 20px;
    border-radius: 20px;
  }
`;

export const Title = styled.h1`
  margin: 0;
  text-align: center;
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 700;
  line-height: 1.2;
  color: #1f1a17;
`;

export const SectionTitle = styled.h2`
  margin: 2rem 0 0.85rem;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.82);
`;

export const Paragraph = styled.p`
  margin: 0 0 1rem;
  color: rgba(0, 0, 0, 0.78);
  font-size: 1rem;
  line-height: 1.85;
`;

export const Ornament = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  margin: 18px 0 34px;
`;

export const OrnLine = styled.div`
  width: 90px;
  height: 1px;
  background: linear-gradient(
    90deg,
    rgba(196, 154, 108, 0),
    rgba(196, 154, 108, 0.95),
    rgba(196, 154, 108, 0)
  );
`;

export const List = styled.ul`
  margin: 0 0 1.1rem 1.25rem;
  padding: 0;
  color: rgba(0, 0, 0, 0.78);
`;

export const ListItem = styled.li`
  margin-bottom: 0.7rem;
  line-height: 1.8;
`;

export const Divider = styled.hr`
  border: none;
  height: 1px;
  margin: 2rem 0;
  background: linear-gradient(
    90deg,
    rgba(196, 154, 108, 0),
    rgba(196, 154, 108, 0.55),
    rgba(196, 154, 108, 0)
  );
`;
